import React from 'react'
import ManagerApproverExpenseReports from 'src/app/ManagerApproverExpenseReports/ManagerApproverExpenseReports'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { managerReviewReimbursementsRouteProps } from 'src/navigation/routeProps'

const ManagerReviewReimbursementsAppRoute: AppRoute = {
  id: AppLocation.ManagerReviewReimbursements,
  routeProps: managerReviewReimbursementsRouteProps,
  component: <ManagerApproverExpenseReports />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ManagerReviewReimbursementsAppRoute